'use strict';

var _ = require('lodash');
var CriteriaRuleModalController = function CriteriaRuleModalController($scope, StrategyConstants) {
  $scope.messages = StrategyConstants.CONFIRMATION_MESSAGES;
  $scope.isFlowTypeConfirmation = function () {
    return _.values($scope.messages.FLOW_TYPE).indexOf($scope.dialogMessageType) > -1;
  };
  $scope.isMessageType = function (messageType) {
    return $scope.dialogMessageType === messageType;
  };
};
CriteriaRuleModalController.$inject = ['$scope', 'StrategyConstants'];
module.exports = CriteriaRuleModalController;